<template>
  <span>
    <feather-icon
      v-b-tooltip.hover.top="
        $t(
          `Global.${
            $can($acl.action.Update, $acl.subjects.Areas)
              ? 'EditSubject'
              : 'ViewSubject'
          }`,
          { subject: $t('Management.Areas.Area') },
        )
      "
      :icon="
        $can($acl.action.Create, $acl.subjects.Areas)
          ? 'Edit2Icon'
          : 'EyeIcon'
      "
      size="16"
      class="hover-primary"
      @click="openSideBar"
    />
    <Form
      ref="form"
      :countries="countries"
      :area="updatedData"
      :submit-btn-text="`${$t('Global.Save')} ${$t(
        'Management.Areas.Area',
      )}`"
      :can="$can($acl.action.Create, $acl.subjects.Areas)"
      :header="$t('Management.Areas.Area') + ' ' + $tc('Global.EditSubject')"
      @submit="submit"
      @openCountryModal="openCountryModal"
    />
  </span>
</template>

<script>
import Form from './form.vue'

export default {
  components: {
    Form,
  },

  props: {
    area: {
      type: Object,
      required: true,
    },
    countries: {
      type: Array,
      default: () => [],
    },
  },

  data: () => ({
    updatedData: null,
  }),

  methods: {
    openCountryModal() {
      this.$emit("openCountryModal");
    },
    openSideBar() {
      this.updatedData = { ...this.area }
      this.$refs.form.sidebarVisible = true
    },
    async submit() {
      try {
        this.updatedData.country = this.updatedData.country?.id
        const { data } = await this.$axios.patch(
          `areas/${this.area.id}`,
          this.updatedData,
        )
        this.updatedData.country = this.countries.find(c => c.id === this.updatedData.country)
        this.$alert.update(data.name)

        Object.keys(this.updatedData).forEach(key => {
          this.area[key] = this.updatedData[key]
        })

        const { form } = this.$refs
        form.dirty = false
        form.sidebarVisible = false
      } catch {
        this.$alert.error()
      }
    },
  },
}
</script>
